import { useEffect } from "react";

const MonitoringSystemRedirect = () => {
  useEffect(() => {
    window.location.href =
      "https://monitoringsistemtermovent.azurewebsites.net/";
  }, []);

  return null;
};

export default MonitoringSystemRedirect;
